import { Error404 } from 'components/errors/error-404';
import { Error500 } from 'components/errors/error-500';
import { Outlet, Route, Routes } from 'react-router-dom';
import { ROUTES } from 'routes';

const ErrorsLayout = () => {
  return <Outlet />;
};

const ErrorsPage = () => (
  <Routes>
    <Route element={<ErrorsLayout />}>
      <Route path="404" element={<Error404 />} />
      <Route path="500" element={<Error500 />} />
      <Route index element={<Error404 />} />
    </Route>
  </Routes>
);

export { ErrorsPage };
